<!-- <mdb-navbar
  SideClass="navbar navbar-conta movil fixed-top navbar-expand-lg navbar-dark "
  [containerInside]="false"
  [iconBackground]="'grey'"
  style="height: 100% !important"
>
  <a
    ><img
      src="../assets/logo.png"
      class="img-responsive center-block text-center img-logo"
      alt="CUBE-logo"
      width="80"
      height="30"
  /></a>
  <links
    style="height: 100% !important"
    class="d-flex justify-content-center align-items-center"
  >
    <ul class="navbar-nav top-nav icon-header ml-auto">
      <li (click)="NavCubeShop('applications')" class="nav-item pr-4">
        <a><i class="fas fa-search c-sfc"></i> Applications</a>
      </li>
      <li class="nav-item pr-4" (click)="NavCubeShop('MyProjects')">
        <a><i class="fas fa-tasks c-sfc"></i> My Projects</a>
      </li>
    </ul>
    <ul class="navbar-nav ml-auto top-nav icon-header">
      <li style="margin: auto">
        <a (click)="NavCubeShop('myCart')"
          ><i class="fas fa-shopping-cart c-sfc"></i
        ></a>
      </li>
      <li
        class="nav-item dropdown d-none d-sm-block"
        dropdown
        style="height: 100% !important; z-index: 1 !important"
      >
        <a
          id="hintUserName"
          dropdownToggle
          mdbWavesEffect
          type="button"
          class="nav-link dropdown-toggle waves-light"
          mdbWavesEffect
        >
          <i class="fas fa-user-circle"></i>
          {{ "TopMenu.labelWelcome" | translate }},<b>{{
            userName$ | async
          }}</b>
          <span class="caret"></span
        ></a>
        <div
          *dropdownMenu
          class="dropdown-menu dropdown-menu-right dropdown dropdown-primary"
          role="menu"
        >
          <a
            id="hintLogOut2"
            class="dropdown-item waves-light"
            mdbWavesEffect
            (click)="popupChangePass = true"
            ><i class="fas fa-sync-alt"></i> Change Password</a
          >

          <a
            id="hintLogOut"
            class="dropdown-item waves-light"
            mdbWavesEffect
            (click)="logOut()"
            ><i class="fa fa-fw fa-power-off"></i>
            {{ "TopMenu.labelLogout" | translate }}</a
          >
        </div>
      </li>
    </ul>
  </links>
</mdb-navbar> -->

<!-- ═══ Shell del portal (diseño CUBE Edge): UNA barra superior de marca con el menu adentro ═══
     Antes habia un sidebar; con solo 4 secciones ocupaba ancho de mas y la pantalla quedaba muy
     blanca. Ahora: logo a la izquierda, las secciones como pestañas y el usuario a la derecha, sobre
     el degradado rojo del portal (el mismo lenguaje que el panel de marca del login).
     No usa las clases .navbar/.navbar-conta: styles.scss les fuerza un alto en % y otros estilos viejos. -->
<header class="cs-topbar">
  <div class="cs-topbar-texture" aria-hidden="true"></div>

  <a class="cs-brand" (click)="NavCube('cs-portal')" title="Dashboard">
    <!-- logo propio de la empresa (white-label) en pastilla blanca; si no hay, la marca de CUBE -->
    <span class="cs-brand-logo" *ngIf="hasCompanyLogo"><img [src]="base64Logo" alt="Company logo"></span>
    <ng-container *ngIf="!hasCompanyLogo">
      <img src="assets/icon.png" alt="" class="cs-brand-cube">
      <span class="cs-brand-word">CUBE</span>
    </ng-container>
    <span class="cs-brand-tag">Customer portal</span>
  </a>

  <nav class="cs-nav" aria-label="Main menu">
    <a *ngFor="let m of menuItems" class="cs-nav-item" [class.active]="isActive(m.route)"
      (click)="NavCube(m.route)" [title]="m.label" [attr.aria-current]="isActive(m.route) ? 'page' : null">
      <i [class]="m.icon"></i><span>{{ m.label }}</span>
    </a>
    <!-- Ocultos desde antes (sus links estaban comentados en el navbar viejo):
         { route: 'cs-serviceHistory', label: 'Service History', icon: 'fas fa-history' }
         { route: 'cs-cubeboxsites', label: 'CubeBox', icon: 'fas fa-map-marked-alt' }
         { route: 'cs-activeProjects', label: 'Active Projects', icon: 'fas fa-tasks' } -->
  </nav>

  <!-- usuario: el boton y el menu viven dentro del mismo wrapper (.cs-user) para que el click
       afuera lo cierre (ver cerrarMenuUsuario en el .ts) -->
  <div class="cs-user">
    <button type="button" class="cs-user-btn" (click)="userMenuOpen = !userMenuOpen"
      [class.is-open]="userMenuOpen" aria-haspopup="true" [attr.aria-expanded]="userMenuOpen">
      <span class="cs-avatar">{{ userInitials }}</span>
      <span class="cs-user-name">{{ userName }}</span>
      <i class="fas fa-chevron-down cs-user-caret"></i>
    </button>
    <div class="cs-user-menu" *ngIf="userMenuOpen" role="menu">
      <div class="cs-user-head">
        <span class="cs-avatar cs-avatar--lg">{{ userInitials }}</span>
        <div>
          <b>{{ userName }}</b>
          <small>{{ userEmail }}</small>
        </div>
      </div>
      <div class="cs-user-divider"></div>
      <button type="button" class="cs-user-item" role="menuitem" (click)="userMenuOpen = false; popupChangePass = true">
        <i class="fas fa-key"></i> Change Password
      </button>
      <div class="cs-user-divider"></div>
      <button type="button" class="cs-user-item cs-user-item--logout" role="menuitem" (click)="userMenuOpen = false; logOut()">
        <i class="fas fa-sign-out-alt"></i> {{ 'TopMenu.labelLogout' | translate }}
      </button>
    </div>
  </div>
</header>

<!-- reserva el alto de la barra fija (56px) + aire, para que las pantallas arranquen debajo -->
<div class="cs-topbar-spacer"></div>

<dx-popover
  target="#link4"
  position="top"
  [width]="400"
  [height]="'auto'"
  [shading]="true"
  shadingColor="rgba(0, 0, 0, 0.5)"
  [(visible)]="popupLayouThemes"
>
  <div *dxTemplate="let data of 'content'">
    <h5 class="text-center">Layout Options</h5>
    <hr />
    <ul class="navbar-nav container-favorite display-container">
      <li class="text-left nav-item" (click)="SetTheme('blue-theme')">
        <a
          ><i class="fas fa-circle" style="color: #03a9f4 !important"></i> Blue
          Light</a
        >
      </li>
      <li class="text-left nav-item" (click)="SetTheme('orange-theme')">
        <a
          ><i
            class="fas fa-circle bg-orange-light"
            style="color: #ea9108 !important"
          ></i>
          Orange Light
        </a>
      </li>
      <li class="nav-item text-left" (click)="SetTheme('palegreen-theme')">
        <a
          ><i class="fas fa-circle" style="color: palegreen !important"></i>
          Palegreen Light
        </a>
      </li>
      <li class="nav-item text-left" (click)="SetTheme('green-theme')">
        <a
          ><i class="fas fa-circle" style="color: green !important"></i> Green
          Light
        </a>
      </li>
    </ul>
  </div>
</dx-popover>

<!-- Cambiar contraseña — rediseño CUBE Edge (antes: titulo armado a mano con los botones encimados
     sobre la X). Mismos campos, mismos ojos (dxi-button) y mismos handlers. -->
<dx-popup [width]="460" [height]="'auto'" [showTitle]="false" [shading]="true" [dragEnabled]="false"
  [(visible)]="popupChangePass" (onShown)="$event.component.repaint()">
  <div class="csm">
    <header class="csm-head">
      <span class="csm-icon"><i class="fas fa-key"></i></span>
      <div class="csm-title">
        <h3>Change password</h3>
        <p>Use one you don't use anywhere else.</p>
      </div>
      <div class="csm-head-actions">
        <button type="button" class="csm-btn csm-btn--secondary" (click)="cancelPopopChangePass()">Cancel</button>
        <button type="button" class="csm-btn csm-btn--primary" (click)="changePass()"
          [disabled]="!modelChangePassword.pass_current || !modelChangePassword.pass || modelChangePassword.pass !== modelChangePassword.confirmPass">
          <i class="fas fa-save"></i> Save password
        </button>
        
      </div>
    </header>
    <div class="csm-body">
      <section class="csm-section">
        <div class="csm-grid">
          <div class="csm-field csm-field--full">
            <label>Current password</label>
            <dx-text-box [(ngModel)]="modelChangePassword.pass_current" [mode]="password" stylingMode="outlined">
              <dxi-button name="buttonPassword" location="after" [icon]="iconButtonPassword" [options]="buttonPassword"></dxi-button>
            </dx-text-box>
          </div>
          <div class="csm-field csm-field--full">
            <label>New password</label>
            <dx-text-box [(ngModel)]="modelChangePassword.pass" [mode]="password1" stylingMode="outlined">
              <dxi-button name="buttonPassword1" location="after" [icon]="iconButtonPassword" [options]="buttonPassword1"></dxi-button>
            </dx-text-box>
          </div>
          <div class="csm-field csm-field--full">
            <label>Confirm new password</label>
            <dx-text-box [(ngModel)]="modelChangePassword.confirmPass" [mode]="password2" stylingMode="outlined">
              <dxi-button name="buttonPassword2" location="after" [icon]="iconButtonPassword" [options]="buttonPassword2"></dxi-button>
            </dx-text-box>
            <span class="csm-hint" *ngIf="modelChangePassword.confirmPass && modelChangePassword.pass !== modelChangePassword.confirmPass"
              style="color:#b42318;">Passwords do not match yet.</span>
          </div>
        </div>
      </section>
    </div>
  </div>
</dx-popup>


<dx-popup [width]="'50%'" [fullScreen]="false" [height]="'auto'" [maxHeight]="'70%'" [showTitle]="true" title="Create New Work Order" [(visible)]="popupNewWorkOrder">

  <div class="row mt-2">
    <div class="col-md-6 ">
      <div class="option mb-2 col-md-12 pb-2">
        <span class="label-style pb-2">
          {{"siteName" | translate}}
        </span>
        <div  class="pt-2">
          <dx-select-box
              [items]="['Aurora Medical', 'Badge Trailer']"
              [(value)]="customer">
          </dx-select-box>
        </div>
      </div>
    </div>
    <div class="col-md-3 ">
      <div class="option mb-2 col-md-12 pb-2">
        <span class="label-style mb-2">
          {{"customerPO" | translate}}
        </span>
        <div  class="pt-2">
          <dx-text-box value=""></dx-text-box>
        </div>
      </div>
    </div>
    <div class="col-md-3 ">
      <div class="option mb-2 col-md-12 pb-2">
        <span class="label-style mb-2">
          {{"priority" | translate}}
        </span>
        <div  class="pt-2">
          <dx-select-box
            [items]="['Hight', 'Normal', 'Low']"
            [(value)]="customer">
          </dx-select-box>
        </div>
      </div>
    </div>  
    
   
    
    <div class="col-md-12">
      <div class="option mb-2 col-md-12">
        <span class="label-style mb-2">
          Reason for Service
        </span>
        <div class="pt-2">
          <dx-text-area [height]="150" placeholder="" >
          </dx-text-area>
        </div>
      </div>
      
    </div>
    <div class="col-md-12 pt-2 pr-4 text-right">
      <dx-button class="mr-2 dark-icon" text="Outlined" icon="close" stylingMode="outlined" text="Cancel"></dx-button>
      <dx-button id="bton-green" icon="check" type="success" text="Save"></dx-button>
    </div>
    
  </div>
</dx-popup>
